import { Link } from "react-router-dom";

export function BillingSuccess() {
  return (
    <section className="rounded-lg border border-slate-200 bg-white p-6">
      <p className="text-sm font-semibold text-emerald-700">Payment confirmed</p>
      <h2 className="mt-2 text-2xl font-semibold tracking-normal text-slate-950">
        You're in
      </h2>
      <p className="mt-3 max-w-2xl text-sm leading-6 text-slate-600">
        Your access will be active shortly — usually within a moment. Head back
        to your dashboard to start building.
      </p>
      <div className="mt-6 flex flex-wrap gap-3">
        <Link
          to="/dashboard"
          className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-indigo-700"
        >
          Go to dashboard
        </Link>
        <Link
          to="/pricing"
          className="rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-100"
        >
          View pricing
        </Link>
      </div>
    </section>
  );
}
